import { useEffect, useState } from "react";
import { loadAllStages } from "./customStagesClient.js";
import { hubItems, type HubItem } from "./hubList.js";

function Row({ id, name, status }: HubItem) {
  return (
    <a className="maker-row" href={`/stage-maker/${id}`}>
      <span>
        <b>{name}</b>
        <small>{status === "draft" ? "下書き" : "公開"}</small>
      </span>
      <span>編集</span>
    </a>
  );
}

export function StageMakerHub() {
  const [listed, setListed] = useState(() => hubItems({}));
  useEffect(() => {
    void loadAllStages(localStorage).then((stored) => setListed(hubItems(stored)));
  }, []);
  return (
    <main className="maker-hub">
      <p className="editor-kicker">STAGE MAKER</p>
      <h1>ステージ</h1>
      <a className="btn btn-primary maker-new" href="/stage-maker/new">新規ステージ</a>
      <h2>下書き</h2>
      {listed.drafts.length === 0 ? <p className="hint">まだない</p> : listed.drafts.map((row) => <Row key={row.id} {...row} />)}
      <h2>公開</h2>
      {listed.published.length === 0 ? <p className="hint">まだない</p> : listed.published.map((row) => <Row key={row.id} {...row} />)}
    </main>
  );
}
